import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ConfirmationComponent } from "@bca-confirmation/confirmation/confirmation.component";
import { AgreementGuard } from "@bca-core/route-guards/agreement.guard";
import { ConfirmationGuard } from "@bca-core/route-guards/confirmation.guard";
import { DialogOpenGuard } from "@bca-core/route-guards/dialog-open.guard";
import { ReceiptCompleteGuard } from "@bca-core/route-guards/receipt-complete.guard";
import { UserDataGuard } from "@bca-core/route-guards/user-data.guard";
import { VerifyGuard } from "@bca-core/route-guards/verify.guard";
import { BcaFlowWindowComponent } from "@bca-flow/bca-flow-window/bca-flow-window.component";
import { CompanyDataGuard } from "@bca/core/route-guards/company-data.guard";

export const routes: Routes = [
  {
    path: "",
    component: BcaFlowWindowComponent,
    canActivate: [ReceiptCompleteGuard],
    canDeactivate: [DialogOpenGuard],
    data: { routeIndex: 0 },
  },
  {
    path: "gegevens",
    component: BcaFlowWindowComponent,
    canActivate: [UserDataGuard, ReceiptCompleteGuard],
    canDeactivate: [DialogOpenGuard],
    data: { routeIndex: 1 },
  },
  {
    path: "controleren",
    component: BcaFlowWindowComponent,
    canActivate: [UserDataGuard, ReceiptCompleteGuard],
    canDeactivate: [DialogOpenGuard],
    data: { routeIndex: 2 },
  },
  {
    path: "bedrijf",
    component: BcaFlowWindowComponent,
    canActivate: [
      UserDataGuard,
      VerifyGuard,
      ReceiptCompleteGuard,
    ],
    canDeactivate: [DialogOpenGuard],
    data: { routeIndex: 3 },
  },
  {
    path: "overeenkomst",
    component: BcaFlowWindowComponent,
    canActivate: [
      UserDataGuard,
      VerifyGuard,
      CompanyDataGuard,
      AgreementGuard,
      ReceiptCompleteGuard,
    ],
    data: { routeIndex: 4 },
  },
  {
    path: "bevestiging",
    component: ConfirmationComponent,
    canActivate: [
      UserDataGuard,
      VerifyGuard,
      CompanyDataGuard,
      AgreementGuard,
      ConfirmationGuard,
    ],
    data: { routeIndex: 5 },
  },
  { path: "**", redirectTo: "" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
    }),
  ],
  exports: [RouterModule],
  providers: [
    UserDataGuard,
    CompanyDataGuard,
    VerifyGuard,
    AgreementGuard,
    ConfirmationGuard,
    ReceiptCompleteGuard,
    DialogOpenGuard,
  ],
})
export class AppRoutingModule {}
